import { Injectable, Inject } from "@angular/core";
import { HttpService, URI } from "../shared/http.service";
import { HttpHeaders } from "@angular/common/http";

@Injectable()
export class GlobalizationHttpService {
  constructor(private httpService: HttpService) { }
  
  public get(lang: string) {
    return this.httpService.get<{ [key: string]: string }>(URI`/api/globalization/${lang}`);
  }
}